export default __webpack_public_path__ + "static/media/pic12.e27d7862.jpg";